import React, { useState, useEffect, memo, lazy, Suspense, useRef } from 'react';
import { useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import ImgIconComp from '../../imgcomp';
import { commentActions } from '../../../actions/comment.actions';
import { okrDetailActions } from '../../../actions/okr/okrDetails.actions';
import GoalServices from '../../../services/goal.services';
import { SetKrContainerHeight } from '../../../utils/function';
import { reactLoader, removeReactLoader, WbMarkdownHtml, isReadOnlyUserLicenseType } from '../../../utils/common';
import { metricProgressColor } from '../../../utils/metricProgressColor';
import { metricEventPageRef, krdetailConstants, metricEventPageRefExtSrc } from '../../../constants/krdetails.constants';
import { okrDetailConstants } from '../../../constants/okr/okrDetails.constants';
import { KeyDownEvent } from '../../../utils/eventKey'
import KrDataSourceIcon from "../../krDataSourceIcon";
import { CopyKrModal } from "../modals/copy-kr-modal";
import { ThemeProvider } from "@workboard/wobo-ui";
import { useTranslation } from 'react-i18next';
import { ClosedStatusChip, useUpdateModalActions } from '@workboard/ui-okr';
import { isKrStatusFilterEnabled } from '../../../utils/okrFilterParams.util';
import { isKeyResultClosed } from '../../../utils/closeKeyResult.util';
import { KR_NAME_PREVIEW_EVENT, applyKrNamePreview, nextKrNamePreview } from '../../../utils/krNamePreview.util';
import { withKrUpdateManager } from '../with-kr-update-modal';

const MetricSourcePopup = lazy(() => import(
  /* webpackChunkName: "kr-source" */
  '../modals/kr-source'
)) ;
const KrHover = lazy(() => import(
  /* webpackChunkName: "kr.hover" */
  '../okr_sub_components/kr.hover.component'
));
const ActivityComponent = lazy(() => import(
  /* webpackChunkName: "ActivityComponent" */
  '../../krDetails/ActivityComponent.component'
));
const KrEmojiHover = lazy(() => import(
  /* webpackChunkName: "kr.emoji.hover" */
  '../okr_sub_components/kr.emoji.hover'
));
const KrModal = lazy(() => import(
  /* webpackChunkName: "kr-modal" */
  './../modals/kr-modal'
));
const ConfidenceFlag = lazy(() => import(
  /* webpackChunkName: "confidenceFlag" */
  '../../common/confidenceFlag.component'
));

export default withKrUpdateManager(memo(function KrRow(props) {
	const dispatch = useDispatch();
	const getKrSourcePopupData = (data) => dispatch(okrDetailActions.fetchKrSourcePopupData(data));
	const iconPath = `${wbConfig.imageCdnUrl}/images/icons/notification/alert-icon.svg`;
	const [showkrHover, setShowkrHover] = useState(false);
	const [showSourcePopup, setShowSourcePopup] = useState(false);
	// const [sourcePopUpData, setSourcePopupData] = useState([]);
	const [showComments, setShowComments] = useState(false);
	const [showEmojiHover, setShowEmojiHover] = useState(false);
	const [showCascadeModal, setShowCascadeModal] = useState(false);
	const [cascadeModalProps, setCascadeModalProps] = useState({});
	const [krHoverFocus, setKrHoverFocus] = useState(false);
	const [focusAddComment, setFocusAddComment] = useState(false);
	const [krNamePreview, setKrNamePreview] = useState(null);
	const [showCopyModell, setShowCopyModel] = useState(false);
	const GoalServicesInstance = new GoalServices();
	const { open: openKrUpdate } = useUpdateModalActions();
	const { metric, loggedInUser, goalStatus, dateStyle = "", goalId, showSourceName = true, refSrc, emojisData, displayKrConfidence, showRealOwner, goalType, parentMetricId='', isChildKr = false } = props;
	const renderDivId = `krCalPopupRenderDiv-${metric.id}`

	useEffect(() => {
		const onKrNamePreview = ({ detail }) => {
			if (String(detail?.metricId) !== String(metric.id)) return;
			setKrNamePreview((prev) => nextKrNamePreview(prev, detail, metric));
		};
		window.addEventListener(KR_NAME_PREVIEW_EVENT, onKrNamePreview);
		return () => window.removeEventListener(KR_NAME_PREVIEW_EVENT, onKrNamePreview);
	}, [metric]);
	const showClosedChip = isKrStatusFilterEnabled(refSrc)
		&& (isKeyResultClosed(metric) || Number(goalStatus) === krdetailConstants.GOAL_CLOSED);
	const canUpdateFromOwnerColumn = loggedInUser == metric.owner && metric.source == krdetailConstants.SOURCE_PERSON
		&& goalStatus == okrDetailConstants.GOAL_ACTIVE && !showClosedChip;
	let refkrCalEvent = '';
	if (refSrc == 'PAGE_TYPE_OKR_I_OWN') {
		refkrCalEvent = 'MY_OKR';
	} else if (refSrc == 'PAGE_TYPE_MY_MANAGER_OKR') {
		refkrCalEvent = 'MANAGER_OKR'
	} else if (refSrc == 'PAGE_TYPE_KR_I_UPDATE') {
		refkrCalEvent = 'MyKey_Results'
	} else if (refSrc == 'PAGE_TYPE_MY_TEAM_OKR') {
		refkrCalEvent = 'TEAM_OKR';
	} else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR_PERSON_OKR') {
		refkrCalEvent = 'PERSON_OKR '
	} else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR') {
		refkrCalEvent = 'TEAM_OKR'
	} else if (refSrc == 'PAGE_TYPE_JUMP_TO_OKR') {
		refkrCalEvent = 'TEAM_OKR_JUMP'
	}else if(refSrc =='PAGE_TYPE_WS_TAB_OKR'){
		refkrCalEvent = 'WORK_STREAMS_KR'
	}

	const setShowCalpopupandtriggerEvent = (v, metricId )=> {
		const GoalServicesInstance = new GoalServices();
    initCalkrPopup(metric, renderDivId, v, metricId, null, null, refkrCalEvent)
		const searchParams = new URLSearchParams(window.location.search);
		window.wb_track('OKR_ACTION', {
			location: searchParams.get('location') || '',
			locationDetail: searchParams.get('locationDetail') || '',
			objectAction: 'VIEW_KR_PROGRESS',
			object: 'KEY_RESULT',
			objectId: metricId,
			teamId: searchParams.get('teamId') || '',
		});

		if (v) {
			GoalServicesInstance.krCalHoverEventTracking({
				'refSrc': "MY_OKR",
				'kr-id': metricId,
			})
		}
    }
	const blueEmojiButton = useRef(null);
	// track click status to prevent from reopening on 'closing' click on initial button
	const clickStatus = useRef(false);
	const getKrComments = (goal_id, id, refSrc, type) => dispatch(commentActions.okrFetchCommentList(goal_id, id, refSrc, type));
	const updateCommentCount = debounce((goalId, metricId, parentMetricId) => dispatch(okrDetailActions.updateCommentCount(goalId, metricId, parentMetricId)), 1500);

	const updateCopy = () => {
		setShowCopyModel(true)
	}

	const setShowModal = () => {
		setShowCopyModel(false)
	}

	useEffect(() => {
		let e = document.querySelector('body');
		if (showCascadeModal) {
			if (e) {
				e.style.overflow = "hidden";
			}
		} else {
			if (e) {
				e.style.overflow = "visible";
			}
		}
		setTimeout(() => SetKrContainerHeight(), 0);
	}, [showCascadeModal, cascadeModalProps])

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('keydown', handleKeyDownOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('keydown', handleKeyDownOutside);
		}
	}, []);

	const handleClickOutside = (e) => {
		if (!e.target.classList.contains('reaction-emojis-container') && !e.target.classList.contains('emoji-icon-btn') && !e.target.classList.contains('reacted-emoji-icon') && !e.target.classList.contains('emoji-icon-img') && !e.target.classList.contains('emoji-count') && !e.target.classList.contains('reaction-emojis-icon-img')) {
			setShowEmojiHover(false);
		}
	}

	const handleKeyDownOutside = (e) => {
		if (!blueEmojiButton.current) {
			setShowEmojiHover(false);
		}
	}

	const toggleKrHover = (val, type, setFocus = false) => {
		const { metric, goalId, parentMetricId } = props;

		if (type == 'showkrHover') {
			setKrHoverFocus(setFocus);
			setShowkrHover(val);
			if (metric.comment_count < 0 && val) {
				updateCommentCount(metric.goal_id || goalId, metric.id, parentMetricId);
			}
		} else if (type == 'showEmojiHover') {
			setShowEmojiHover(val);
		} else if (type == 'showComments') {
			setShowComments(val);
		}
	}

	const toggleKrSourcePopup = (val, metric) => {
		if (metric && (metric.source == 2 || metric.source == 11 || (metric.type == 1 && metric.source == 3))) {
			if (!showSourcePopup && metric && (!metric.sourcePopupDetails || metric.sourcePopupDetails.length === 0)) {
				getKrSourcePopupData({
					goalId: metric.goal_id,
					userId: metric.owner,
					metricId: metric.id
				});
			}
			setShowSourcePopup(val);
		}
	}

	const viewGoalDetails = (e, metric, source) => {
		const searchParams = new URLSearchParams(window.location.search);
		window.wb_track('OKR_ACTION', {
			location: searchParams.get('location') || '',
			locationDetail: searchParams.get('locationDetail') || '',
			objectAction: 'VIEW',
			object: 'KEY_RESULT',
			objectDetail: 'KEY_RESULT_PAGE',
			objectId: metric.id,
			teamId: searchParams.get('teamId') || '',
		});
		const krSidePanelOn = Boolean(window.wbConfig && window.wbConfig.isFederatedKrSidePanelDefault);
		// Modified or non-primary click: let the browser open the <a target=_blank> natively.
		const modified = e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0;
		if (krSidePanelOn && modified) return;
		if (e.ctrlKey || e.metaKey){
			window.open(this.href);
		  }else{
			e.preventDefault()
			let refSource = null;
			if(source != undefined) {
				refSource = source;
			}
			// Panel stays on the page, so skip the one-shot clickedAlready latch (it is never reset).
			if (krSidePanelOn && typeof window.openFederatedKrSidePanel === 'function') {
				e.stopPropagation();
				if (metric.cascade_goal_id != null || metric.parent_goal_id != null) {
					return metricDetailsPage(metric.id);
				}
				return krDetailPage(metric.id, refSource, true);
			}
			if (Object.keys(props).includes('clickedAlready') && !props.clickedAlready) {
				e.stopPropagation();
				if (metric.cascade_goal_id != null || metric.parent_goal_id != null) {
					return metricDetailsPage(metric.id);
				}
				else {
					props.cbClickedAlready();
					return krDetailPage(metric.id, refSource, true);
				}
			} else if (!Object.keys(props).includes('clickedAlready')) {
				e.stopPropagation();
				if (metric.cascade_goal_id != null || metric.parent_goal_id != null) {
					return metricDetailsPage(metric.id);
				}
				else return krDetailPage(metric.id, refSource, true);
			}
		  }
	}

	const metricUpdate = (item, _ = null) => {
		const metricId = item.id;
		openKrUpdate({
			krId: metricId,
			source: item.source,
			metricUpdate: true
		})
	}

	const handleKeyDown = (e, metric, checkActivation = true, refSrc = null) => {
		if(checkActivation) {
			if(e.key === "Enter" || e.key === " "){
			e.preventDefault();
			metricUpdate(metric, refSrc);
		}
		}
		if (!e.shiftKey && e.key === "Tab") {
			toggleKrHover(true, 'showkrHover', true)
		}
	}


	const toggleMetricComments = (metric, refSrc, type) => {
		// check metric object
		if (typeof metric.id !== 'undefined') {
			let goalId = metric.goal_id;
			if (typeof metric.cascade_goal_id !== 'undefined' && metric.cascade_goal_id != null) {
				goalId = metric.cascade_goal_id;
			}
			else if (typeof metric.parent_goal_id !== 'undefined' && metric.parent_goal_id != null) {
				goalId = metric.parent_goal_id;
			}
			getKrComments(goalId, metric.id, refSrc, type);
		}
		setShowComments(!showComments);
	}

	const setFocusToAddComment = (val) => {
		setFocusAddComment(val)
	}

	const cascadeEditModal = (item) => {
		reactLoader();
		let params = {};
		params.metricId = item.id;
		params.cascadeReq = true;
		GoalServicesInstance.createCascadeDetails(params)
			.then((response) => {
				removeReactLoader();
				if (response.data) {
					setShowCascadeModal(true);
					setCascadeModalProps(response.data.data);
				}
			})
			.catch(function (error) {
				if (error.response) {
					removeReactLoader();
				}
			});
	}

	const closeCascadeModal = () => {
		setShowCascadeModal(false);
	}

	const displayMetricName = (m) => {
		let { krQuarterName = '' } = m;

		if (krQuarterName) {
			krQuarterName += ': ';
			if (m.name.indexOf(krQuarterName) != 0) {
				return krQuarterName + m.name;
			}

		}
		return m.name;
	}

	const displayQuarterDate = (m) => {
		const { krQuarterDateText = '' } = m;
		return `${krQuarterDateText}`;
	}

	let showUpdateLink = false;
	if (showRealOwner && (refSrc == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE || refSrc == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH ||
		refSrc == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR) && goalStatus == okrDetailConstants.GOAL_ACTIVE) {
		showUpdateLink = true;
	}
	const showUpdateLinkOverMetricName = (((showRealOwner && loggedInUser == metric.real_owner && !isChildMIT) ||
															(!showRealOwner && loggedInUser == metric.owner)) &&
															metric.source == krdetailConstants.SOURCE_PERSON && goalStatus == okrDetailConstants.GOAL_ACTIVE
															&& !showClosedChip)
	let canUpdateLinkFlag = ((loggedInUser == metric.owner && metric.source == krdetailConstants.SOURCE_PERSON) ||
		metric.canUpdate && (metric.source == krdetailConstants.SOURCE_SURVEY || metric.source == krdetailConstants.SOURCE_PERSON)) ? true : false;
	let refSrcRow = '';
	if (refSrc == 'PAGE_TYPE_OKR_I_OWN' || refSrc == 'PAGE_TYPE_KR_I_UPDATE' || refSrc == 'PAGE_TYPE_MY_TEAM_OKR' || refSrc == 'PAGE_TYPE_MY_MANAGER_OKR') {
		refSrcRow = 'MY_OKR'
	} else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR' || refSrc == 'PAGE_TYPE_MY_DIRECT_OKR' || refSrc == 'PAGE_TYPE_MY_DIRECT_KR') {
		refSrcRow = 'TEAM_OKR';
	} else if (refSrc == 'PAGE_TYPE_JUMP_TO_OKR') {
		refSrcRow = 'TEAM_OKR_JUMP';
	}
	let krCustomClass = '';
	if (refSrc == 'PAGE_TYPE_KR_I_UPDATE') {
		krCustomClass = 'myKRResultsCustomStyle'
	}
	if (metric.sourceText.indexOf('KR Studio') > -1) {
		metric.sourceText = 'KR Studio';
	}
	let type;
	let refSrcMetricEvent = '';
	if (refSrc == 'PAGE_TYPE_OKR_I_OWN') {
		refSrcMetricEvent = 'MY_OKR';
	} else if (refSrc == 'PAGE_TYPE_MY_MANAGER_OKR') {
		refSrcMetricEvent = 'MANAGER_OKR'
	} else if (refSrc == 'PAGE_TYPE_MY_TEAM_OKR') {
		refSrcMetricEvent = 'TEAM_OKR';
	} else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR_PERSON_OKR') {//need to add
		refSrcMetricEvent = 'PERSON_OKR '
	} else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR') {
		refSrcMetricEvent = 'TEAM_OKR'
	} else if (refSrc == 'PAGE_TYPE_JUMP_TO_OKR') {
		refSrcMetricEvent = 'TEAM_OKR_JUMP'
	}
	if (metric.source == krdetailConstants.SOURCE_EXT_SOURCES) {
		type = metricEventPageRefExtSrc[metric.ext_app_id];
	} else {
		type = metricEventPageRef[metric.source];
	}

	let metricEventParams = {
		'refSrc': refSrcMetricEvent,
		'kr-id': metric.id,
		'type': type
	}

	const roleUpdateLink = showUpdateLinkOverMetricName ? 'button' : 'tooltip';
	const tabIndexUpdateLink = (showUpdateLinkOverMetricName || metric.owner_name) ? 0 : null;
	const isTitleLink = (metric.source == 2 || metric.source == 11);
	const isMetricSourceText = ((metric.source == 5
								|| metric.sourceText !== metric.owner_name)
								? `Data from ${metric.sourceText}` : metric.sourceText)
	const metricSourceText = showRealOwner ? isMetricSourceText : metric.sourceText;
	const titleUpdateLink = (isTitleLink || (metric.type == 1 && metric.source == 3)) ? '' : metricSourceText;
	const isChildMIT = (typeof props.nestedKr !== 'undefined' && props.nestedKr
		&& (typeof metric.isChildMIT !== 'undefined' && metric.isChildMIT)) ? true : false;

	const changeShowEmojiHoverState = (val) => {
		toggleKrHover(val, 'showEmojiHover')
	}
	const { t } = useTranslation();
	return (
		<>
			<div data-test="krRowComponent" className={`goal-metric-table  ${krCustomClass}`} key={`kr-row-${metric.id}`} style={showComments ? { border: "1px solid #d7dde5", borderRadius: "4px" } : {}}>
				<div className="goal-table-div"
					onMouseEnter={() => toggleKrHover(true, 'showkrHover')}
					onMouseLeave={() => toggleKrHover(false, 'showkrHover')}
					style={{ position: 'relative', paddingRight: '50px' }}
				>
					<div className="goal-table">
						<div className="goal-table-row tableRowBorder" style={props.rIndex!=0  ? { borderTop: 0 } : {}}  data-goal-id={metric.goal_id} data-metric-id={metric.id} >
							<div className="col-1">


								<div className={`goal-table-col wb-metric-col-target  colMetricTarget ${props.nestedKr ? "nested-kr" : ''}`}
									style={(displayKrConfidence && metric.confidence) ? { 'position': 'initial' } : {}}

								>
							    <span className='krColHover'
								tabIndex={0}
								onKeyDown={e => {
									(e.key === 'Enter'|| e.key === '') && setShowCalpopupandtriggerEvent?.(true, metric.id)
									(e.key === 'Escape'|| e.key === ''||e.key =='Shift'|| e.key === 'Tab') && setShowCalpopupandtriggerEvent?.(false, metric.id)
								}
								}
								onClick={(e) => setShowCalpopupandtriggerEvent(true, metric.id)
								}
								>
									<div className='screen-reader-only'>
										{`${t('Progress')}:`} {`${metricProgressColor[metric.progress_color.toLowerCase()] ? metricProgressColor[metric.progress_color.toLowerCase()] : ''} `}
									</div>
									<span className="wb-goal-achieve-text" data-testid="wb-goal-achieve-text" style={{ color: (metric.progress_color ? metric.progress_color : '#55BAD5') }}>
										{metric.achieveTargetText}
									</span>
									{
										metric.targetDisplay &&
										<span className="wb-goal-target-text" data-testid="wb-goal-target-text">
											{' '}
											{t('of')}
											{' '}
											{metric.totalTargetText}
											{' '}
										</span>
									}

									{displayKrConfidence ? (metric.confidence && metric.confidence.confidence != 0 && metric.confidence.confidence != undefined ?
										<Suspense fallback={null}>
											<ConfidenceFlag
												type={metric.confidence.confidence}
												cDate={metric.confidence.created_at_formatted}
												uName={metric.confidence.added_by_name}
												comment={metric.confidence.comment}
												id={metric.id}
												classProp={'krRow'}
												style={{ 'paddingLeft': '5px', 'marginBottom': '-2px' }}
												useNewConfidenceFlag
											/>
										</Suspense>
										: <span id="confIt-void" className="confidenceIcon"></span>) : ''
									}
									</span>
								</div>
								<div id={renderDivId} style={{ position: 'absolute' }}/>
								<a href={wbConfig.baseUrl + "/goal/krDetails?id=" + metric.id} target={"_blank"} className="goal-table-col wb-metric-col-goal colMetricGoal"
									onClick={(e) => viewGoalDetails(e, metric, refSrc)}
									id={"kr-row-"+ metric.id}
								>
									<div className="goal-metric-name" data-testid="kr-row-metric-name" onClick={(e) => viewGoalDetails(e, metric, refSrc)} style={{ fontSize: '14px', fontWeight: 'normal', lineHeight: '1.4' }}>
										<span className="screen-reader-only">{`${t('Key Result')}:`} </span>
                    					<span id={`kr-id-${metric.id}`}>{krNamePreview?.metric === metric ? applyKrNamePreview(displayMetricName(metric), krNamePreview) : displayMetricName(metric)}</span>
										{showClosedChip && !showSourceName && <ClosedStatusChip />}
									</div>
									{/* <div className="goal-table-col wb-metric-col-date colMetricUpdated" id={metric.id}> {displayQuarterDate(metric)} </div> */}
								</a>
								<div className="goal-table-col krReactionCount">
									{
										metric.emoji_count > 0 &&
										<div className="okr-icon-thumb-up"
											onMouseEnter={() => toggleKrHover(true, 'showEmojiHover')}
											onMouseLeave={() => toggleKrHover(false, 'showEmojiHover')}
											onClick={(e) => toggleKrHover(true, 'showEmojiHover')}
											onKeyDown={(e) => KeyDownEvent(e, () => toggleKrHover(true, 'showEmojiHover'))}
											id={'okr-icon-thumb-up-' + metric.id}
											aria-label={t('reaction button')}
											aria-haspopup={true}
											tabIndex='0'
											role='application'
											ref={blueEmojiButton}
											aria-controls="reaction-menu-id"
										>
											<span className="icon icon-thumb_up-14px-blue"></span>
											<span>{metric.emoji_count}</span>
											{
												showEmojiHover &&
												<Suspense fallback={null}>
													<KrEmojiHover
														metric={metric}
														emojisData={emojisData}
														krRowEmojis={showEmojiHover}
														parentMetricId={parentMetricId}
														goalId={props.goalId}
														changeShowEmojiHoverState={changeShowEmojiHoverState}
														emojiFocusId={'okr-icon-thumb-up-' + metric.id}
													/>
												</Suspense>
											}
										</div>
									}
								</div>
							</div>
							<div className="col-2" style={{ minWidth: '350px', flexShrink: 0 }}>
								{ showSourceName && (
									canUpdateFromOwnerColumn
										? (
											<button className="goal-table-col wb-metric-col-author colMetricAuther clr-btn-def-style"
											    data-testid='goal-table-col-update'
												onKeyDown={(e) => handleKeyDown(e, metric, showUpdateLinkOverMetricName, refSrcRow)}
												onClick={() => metricUpdate(metric, refSrcRow)}
												id={"update-button-" + metric.id}
												style={{ minWidth: '180px' }}
											>
												<div className="truncateText" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
													<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flexShrink: 1, minWidth: 0 }}>{metric.owner_name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
													{!isReadOnlyUserLicenseType() && <div style={{ flexShrink: 0, whiteSpace: 'nowrap' }}><span>
														<ImgIconComp id="clock_img"/>
													</span>
													<span className="blueFont">&nbsp;&nbsp;{t('Update')}</span></div>}
												</div>
											</button>
										)
										:
										(

											<div
												className="goal-table-col wb-metric-col-author colMetricAuther"
												onMouseDown={() => { clickStatus.current = showSourcePopup; }}
												onClick={() => toggleKrSourcePopup(!clickStatus.current, metric) }
												style={{ minWidth: '180px' }}
											>
												{
													showSourcePopup
													&&
													<Suspense fallback={null}>
														<MetricSourcePopup sourcePopupDetails={metric.sourcePopupDetails} source={metric.source} metricEventParams={metricEventParams} close={() => toggleKrSourcePopup(false, metric)}/>
													</Suspense>
												}
												<div className="truncateText "
													role={roleUpdateLink}
													onKeyDown={(e) => handleKeyDown(e, metric, showUpdateLinkOverMetricName, refSrcRow)}
													tabIndex={tabIndexUpdateLink}
													style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
													title={metric.pingText || titleUpdateLink}
													>
													<div className="author-text" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flexShrink: 1, minWidth: 0 }}>
														<span className="screen-reader-only">{`${t('Owner')}:`} </span>
														{canUpdateFromOwnerColumn ? (
															<span>{metric.owner_name}</span>
														)
															:
															(metric.owner_name)

														}

													</div>
													{canUpdateFromOwnerColumn && !isReadOnlyUserLicenseType() && (
														<div style={{ flexShrink: 0, whiteSpace: 'nowrap', marginLeft: '5px' }}>
															<span>
																<ImgIconComp id="clock_img" />
															</span>
															<span className="blueFont">&nbsp;&nbsp;{t('Update')}</span>
														</div>
													)}
													{
														showRealOwner
														&& <KrDataSourceIcon
															kr={metric}
															isOwnerTheDataSource={metric.owner === metric.real_owner}
															className="author-icon"
															style={showSourcePopup ? {
																backgroundColor: 'rgba(0, 0, 0, 0.08)',
																outline: '2px solid rgba(0, 0, 0, 0.08)',
																borderRadius: '50%',
															} : {}}
														/>
													}
													<div>
														{
															props.notificationsData ? (metric.kpi_failure_message && props.notificationsData[parseInt(metric.ext_app_id)]?.visibility)?
															(
																<img title={`${metric.kpi_failure_message.errorMessage}.`} role="button" tabIndex="0" width="18.33px" height="15.83px"
																style={{marginLeft:"0.83px", cursor: 'pointer'}}
																src={iconPath}
																/>
															)
															:
															""
															:
															""
														}
													</div>
													{/* Right edge of the owner column, so Closed pills line up */}
													{showClosedChip && <div style={{ marginLeft: 'auto', flexShrink: 0 }}><ClosedStatusChip /></div>}
												</div>
											</div>

										)
								)
								}
								{
									!isReadOnlyUserLicenseType() && showUpdateLink &&
									<div className="goal-table-col wb-metric-col-author colMetricAuther" onClick={() => metricUpdate(metric, refSrcRow)}
										role="button"
										onKeyDown={(e) => handleKeyDown(e, metric, showUpdateLinkOverMetricName, refSrcRow)}
										tabIndex={canUpdateLinkFlag ? "0" : null}
									>
										{
											canUpdateLinkFlag ?
												<div className="truncateText" style={{ cursor: 'pointer' }}>
													<span></span>
													<span>
														<ImgIconComp id="clock_img" />
													</span>
													<span className="blueFont">&nbsp;&nbsp;{t('Update')}</span>
												</div> :
												<div className="truncateText">
													&nbsp;
												</div>
										}
									</div>
								}
								<span className="screen-reader-only" >{`${t('Lst Updated')}:`} </span>
								<div className="goal-table-col wb-metric-col-date colMetricUpdated" style={{ ...dateStyle, marginRight: '15px', paddingRight: '10px' }}
									dangerouslySetInnerHTML={WbMarkdownHtml(metric.displayDateText, true)}
								/>
							</div>
						</div>
					</div>
					{
							<Suspense fallback={null}>
								<KrHover copy={updateCopy} refSrcOKR={props.refSrc} metric={metric} goalStatus={goalStatus} goalId={goalId} toggleKrHover={toggleKrHover}
									viewMetricComments={toggleMetricComments} emojisData={emojisData} cascadeEditModal={cascadeEditModal}
										isChildKr={isChildKr} parentMetricId={parentMetricId} showComments={showComments} krHoverFocus={krHoverFocus} setFocusToAddComment={setFocusToAddComment}
									/>
							</Suspense>

					}
				</div>
				{showComments &&
					<Suspense fallback={null}>
						<ActivityComponent
							metric={metric}
							goalType = {goalType}
							refSrc={refSrcRow}
							closeMetricComments={toggleMetricComments}
							parentMetricId={parentMetricId}
							initialFocus={focusAddComment}
							toggleKrHover={toggleKrHover}
						/>
					</Suspense>
				}
				{
					(showCascadeModal && cascadeModalProps.cascadeMetric) && (
            <Suspense fallback={null}>
							<KrModal isOpen={showCascadeModal} handleCloseModal={closeCascadeModal} data={cascadeModalProps} />
						</Suspense>
					)
				}
				{showCopyModell &&
					<ThemeProvider>
						<CopyKrModal
							key={'goal-search'}
							metric={props.metric}
							isOpen={showCopyModell}
							handleClose={() => setShowCopyModel(false)}
							{...props}
						/>
					</ThemeProvider>
				}
			</div>
	</>
	);
}), 'TEAM_PAGE');

// const mapDispatchToProps = (dispatch) => ({
// 	getKrSourcePopupData: (data) => dispatch(okrDetailActions.fetchKrSourcePopupData(data)),
// 	getKrComments: (goal_id, id, refSrc, type) => dispatch(commentActions.okrFetchCommentList(goal_id, id, refSrc, type)),
// 	updateCommentCount: (goalId, metricId) => dispatch(okrDetailActions.updateCommentCount(goalId, metricId))
// });

// const mapStateToProps = state => {
// 	return state;
// };
